import { Component, Input } from '@angular/core';
import { PaymentMethodSelectionElementComponent } from './payment-method-selection-element/payment-method-selection-element.component';
import { SelectablePaymentType } from 'app/shared/models/payment-configuration.model';

@Component({
  selector: 'ez-payment-method-selection',
  imports: [PaymentMethodSelectionElementComponent],
  templateUrl: './payment-method-selection.component.html',
  styleUrl: './payment-method-selection.component.scss',
})
export class PaymentMethodSelectionComponent {
  @Input({ required: true }) paymentMethods: SelectablePaymentType[] = [];
  @Input({ required: true }) controlName: string;
}
